import Image from 'next/image'

interface Props {
  title?: string
  brands: StrapiImageFile[]
}

function CustomerLogos({ title, brands }: Props): JSX.Element {
  return (
    <section className="container | py-10 md:py-18">
      {title && (
        <h2 className="font-heading text-2xl md:text-4xl text-center font-semibold | mb-10">
          {title}
        </h2>
      )}
      <div className="flex flex-wrap gap-8 lg:gap-10 justify-center | max-w-4xl mx-auto">
        {brands.map(brand => {
          return (
            <Image
              key={brand.url}
              src={brand.url}
              alt={brand.alternativeText ?? ''}
              width={brand.width}
              height={brand.height}
              className="w-22 h-10 md:w-32 md:h-14 object-contain"
            />
          )
        })}
      </div>
    </section>
  )
}

export default CustomerLogos
